import { getConfig } from '@local/app-config';
import { Component } from 'react';
import { initializeErrorLogging, logUnknownException } from './errorLogging';
import { Severity } from './errorLogging.types';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidMount() {
        const appConfig = getConfig();
        const { sentryDSN, releaseVersion, beforeSend } = this.props;
        const loggingConfig = {
            dataSourceName: sentryDSN,
            environment: appConfig === null || appConfig === void 0 ? void 0 : appConfig.environment,
            release: releaseVersion,
            beforeSend,
        };
        initializeErrorLogging(loggingConfig);
    }
    componentDidCatch(error) {
        const errorId = logUnknownException(error, Severity.Fatal);
        this.setState({ errorId });
    }
    render() {
        const { hasError, errorId } = this.state;
        const { errorComponent, children } = this.props;
        if (hasError) {
            return typeof errorComponent === 'function' ? errorComponent(errorId) : errorComponent;
        }
        return children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map